<script setup lang="ts">
interface NavbarProps {
  title?: string
  leftText?: string
  rightText?: string
  leftDisabled?: boolean
  rightDisabled?: boolean
  leftArrow?: boolean
  border?: boolean
  fixed?: boolean
  placeholder?: boolean
  zIndex?: number | string
  safeAreaInsetTop?: boolean
  clickable?: boolean
  clientLeft?: (event: MouseEvent) => void
  clientRight?: (event: MouseEvent) => void
}

const props = withDefaults(defineProps<NavbarProps>(), {
  title: '',
  leftText: '',
  rightText: '',
  leftDisabled: false,
  rightDisabled: false,
  leftArrow: false,
  border: true,
  fixed: false,
  placeholder: false,
  zIndex: 1,
  safeAreaInsetTop: false,
  clickable: true,
})

const slots = useSlots()
</script>

<template>
  <van-nav-bar v-bind="{ ...props }">
    <template
      v-if="slots.left"
      #left
    >
      <slot name="left" />
    </template>
    <template
      v-if="slots.title"
      #title
    >
      <slot name="title" />
    </template>
    <template
      v-if="slots.right"
      #right
    >
      <slot name="right" />
    </template>
  </van-nav-bar>
</template>
